import { keyframes, styled } from '@mui/material';
import type { Theme } from '@mui/material';
import hexToRgb from 'hex-rgb';

const pulsatingBoxShadow = (theme: Theme) => keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.19), 0 0 0 0 rgba(${[
        ...hexToRgb(theme.bino.color.green + '26', { format: 'array' }),
    ].join(',')});
  }
  50% {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.19), 0 0 0 8px rgba(${[
        ...hexToRgb(theme.bino.color.green + '26', { format: 'array' }),
    ].join(',')});
  }
  75% {}
  100% {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.19), 0 0 0 8px rgba(${[
        ...hexToRgb(theme.bino.color.green + '0a', { format: 'array' }),
    ].join(',')});
  }
`;

const pulsatingDot = keyframes`
  0% {
    opacity: 0.5;
  }
  25% {
    opacity: 1
  }
`;

export const CollectingDataIcon = styled('div')(({ theme }) => ({
    display: 'block',
    margin: '0 auto 8px auto',
    width: 24,
    height: 24,
    position: 'relative',
    borderRadius: 24,
    background: theme.bino.color.white,
    boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.19), 0 0 0 8px rgba(${[
        ...hexToRgb(theme.bino.color.green + '26', { format: 'array' }),
    ].join(',')})`,
    animation: `${pulsatingBoxShadow(theme)} infinite ease-in 1s`,

    '&:before': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        margin: '-6px 0 0 -6px',
        width: 12,
        height: 12,
        borderRadius: 12,
        background: theme.bino.color.darkGreen,
        animation: `${pulsatingDot} infinite ease-in 1s`,
    },
}));
